import { fullPageReloadWithDelay } from '@/utils/reload.ts';

export const handleChunkLoadError = (error: Error) => {
  const errorMessage = error?.message || '';

  // Check if this is a chunk loading error
  if (errorMessage.includes('Loading chunk')) {
    fullPageReloadWithDelay(1000);
  }
};
